<template>

  <div>

    <b-modal size="lg" v-model="modalFields" id="modal-scrollable" hide-footer
             :title="'Campos etapa: ' + modalFieldsName ">
      <GroupProductField v-if="modalFields" :foreign-key="modalFieldsGroupProductId"/>
    </b-modal>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="groupProductId"
                 :header-margin-right="'200px'"
                 @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault">

      <template #default>

        <t-input v-model="form.groupProductId" hidden/>

        <b-col cols="12" class="mb-2">

          <b-row>

            <b-col xl="9">

              <b-row>

                <t-input cols="4" v-model="form.name"  :add-error="error.name" label="Grupo de Produto"
                         required/>
                <t-input cols="4" v-model="form.note" label="Observação"/>

                <b-col md="4">

                  <b-row>

                    <t-input
                        v-model="form.codeGeneratorPrefix" :add-error="error.codeGeneratorPrefix"
                        :disabled="!form.codeGeneratorUsing"
                        :required="form.codeGeneratorUsing"
                        cols="6" upper max-length="10" only-letters-and-numbers label="Prefixo"/>

                    <t-input cols="6" :disabled="!form.codeGeneratorUsing" :required="form.codeGeneratorUsing"
                             v-model="form.codeGeneratorQtdNumbers" :options="formatOptions" select-common
                             label="Formato"
                             help="Sistema ferá quebra de contagem por grupo de produto e irá formatar a visualização com a seguinte máscara. * Caso nenhuma regra customizada especial tenha sido aplicada."/>

                  </b-row>

                </b-col>

                <b-form-checkbox class="col-sm-12 ml-3" v-model="form.codeGeneratorUsing" switch>
                  <small>Gerar código nos produtos?</small>
                  <t-help
                      title="Utilize o gerador de código automatico nos produtos conforme a regra desejada. Podendo utilizar prefixo e qtd. de caracteres desejados."/>
                </b-form-checkbox>

                <b-form-checkbox class="col-sm-12 ml-3" v-model="form.nameGeneratorUsing" switch>
                  <small>Gerar nome nos produtos?</small>
                  <t-help
                      title="Utilize o gerador de nome automatico em combinação com os campos de medidas e que estejam marcados com a opção 'Utilizar para compor nome do produto'."/>
                </b-form-checkbox>

              </b-row>

            </b-col>

            <b-col xl="3" class="button-form-inline">

              <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command)" no-icon submit/>

              <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
                {{ t('go-back') }}
              </b-link>

            </b-col>

          </b-row>

        </b-col>

      </template>

      <template #item(codeGeneratorUsing)="{item}">

        <span v-if="item.codeGeneratorUsing">
          {{ t('yes') }} - {{ item.codeGeneratorPrefix }} - {{ 0 | lpad(item.codeGeneratorQtdNumbers) }}
        </span>
        <span v-else>
          {{ t('no') }}
        </span>

      </template>

      <template #list-buttons="{item}">

        <t-button small @click="openModalFields(item.groupProductId, item.name)" class="mr-4">
          <b-icon-card-text></b-icon-card-text>
          Campos
        </t-button>

      </template>

    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"

import GroupProductField from "@/views/modules/product/GroupProductField";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {GroupProductField, tFormList},
  name: 'GroupProduct',
  data() {
    return {
      path: "product/group", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "familyProductId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "groupNumber", keyDelete: "groupProductId"},
        {key: "name", label: "Grupo de Produto", cols: "5"},
        {key: "codeGeneratorUsing", label: "Gerar Código", cols: "3"},
        {key: "nameGeneratorUsing", label: "Gerar Nome", cols: "2", formatter: "boolean"},
        {key: "note", label: "Obs.", cols: "2"},
      ],
      form: {
        familyProductId: this.foreignKey,
        //---------------------------------------------------------------
        //PADRÃO FORMULÁRIO GROUP-PRODUCT
        groupProductId: 0,
        name: "",
        note: "",
        codeGeneratorUsing: true,
        nameGeneratorUsing: false,
        codeGeneratorPrefix: "",
        codeGeneratorQtdNumbers: 4,
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        codeGeneratorPrefix: "",
      },
      formatOptions: [
        {value: 1, text: "0"},
        {value: 2, text: "00"},
        {value: 3, text: "000"},
        {value: 4, text: "0000"},
        {value: 5, text: "00000"},
        {value: 6, text: "000000"}
      ],
      //FIM FORMULÁRIO PADRÃO GROUP PRODUCT -------------------------------
      modalFields: false,
      modalFieldsName: "",
      modalFieldsGroupProductId: 0,


      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
        "codeGeneratorUsing",
        "codeGeneratorQtdNumbers"
      ],
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

      if (!this.form.codeGeneratorUsing) {
        this.form.codeGeneratorQtdNumbers = 0
      }

    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.groupProductId)

    },

    mountedList() {

      // Manipulação da listagem após carregando
      //--------------------------------------
      /*let newItems = []

      for (let item of this.items) {

        newItems.push(item)

      }

      this.items = newItems*/
      //--------------------------------------

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    openModalFields(id, name) {
      this.modalFields = true
      this.modalFieldsName = name
      this.modalFieldsGroupProductId = id
    },

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
